var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-mask" }, [
    _c("div", { staticClass: "modal-wrapper" }, [
      _c("div", { staticClass: "modal_size lg_size" }, [
        _c(
          "a",
          {
            staticClass: "ui_close",
            attrs: { href: "javascript:", type: "button" },
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [_c("span", { staticClass: "sr_only" }, [_vm._v("popup close")])]
        ),
        _vm._v(" "),
        _c("dl", { staticClass: "modal_content" }, [
          _c("dt", { staticClass: "ellipsis" }, [
            _c("i", [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.LIST")))])
          ]),
          _vm._v(" "),
          _c("dd", [
            !_vm.isLoading
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "resize",
                        rawName: "v-resize",
                        value: _vm.setGridResizeColumn,
                        expression: "setGridResizeColumn"
                      }
                    ],
                    staticClass: "grid_wrap only_grid"
                  },
                  [
                    _c("content-grid", {
                      ref: _vm.gridId,
                      attrs: {
                        gridId: _vm.gridId,
                        columns: _vm.columns,
                        data: _vm.gridData,
                        options: _vm.options,
                        pageOptions: _vm.pageOptions,
                        isTotalCount: false,
                        click: _vm.contentClick
                      },
                      on: { "grid-total-count": _vm.setTotalCount }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "paginate" },
                      [
                        _c("sdl-pagination", {
                          attrs: {
                            align: "center",
                            "current-page": _vm.currentPage,
                            "total-rows": _vm.totalCount,
                            "per-page": _vm.perPage
                          },
                          on: { change: _vm.movePage }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("dd", { staticClass: "scroll_btm" }, [
            _c("div", { staticClass: "btn_modal_wrap topLine" }, [
              _c("div", { staticClass: "btn_right" }, [
                _c(
                  "a",
                  {
                    staticClass: "btn_white",
                    attrs: { href: "javascript:" },
                    on: {
                      click: function($event) {
                        return _vm.$emit("close")
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.CLOSE")))]
                )
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fa17c226", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa17c226","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/dashboard/popup/DashboardConfigContentsListPopup.vue
// module id = aN5m
// module chunks = 0